import { AnimatePresence, motion } from "framer-motion";
import { FC, useEffect, useState } from "react";

import { SheetClose } from "~/components/ui/sheet";
import useAuthRoute from "~/hook/useAuthRoute";
import { useFontStyle } from "~/hook/useFontStyle";
import { getSession } from "~/lib/helperFuncation/sessionStorageService";
import { listItemVariants, touchVariants } from "~/lib/motion-obj";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_URL, SELECTED_ITEM } from "~/utils/constant";
import { wantsMobile } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "./type";

const ListView: FC<PropsType> = ({ data, category_name, shape, isImagePreloaded }) => {
  const [selectedList, setSelectedList] = useState<number | null>(Number(getSession(SELECTED_ITEM)) || null);
  // const { LocalizedLink } = useLocale();
  const { handleNavigate } = useAuthRoute();
  const { medium, regular } = useFontStyle();

  useEffect(() => {
    sessionStorage.setItem(SELECTED_ITEM, JSON.stringify(selectedList));
  }, [selectedList]);

  return (
    <div className="flex flex-col px-5  mb-5">
      {category_name && (
        <div className={cn("-px-2 my-2")}>
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}
      <AnimatePresence>
        <div>
          {data.map((item, index) => {
            const isVisible = wantsMobile(item.show_menu);
            return (
              isVisible && (
                <div
                  key={item.id}
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                >
                  <SheetClose
                    className={cn(
                      "w-full flex items-center gap-x-2 pt-0.5 pb-1.5 border-b border-b-lightAshGray",
                      selectedList === item.id && "border-l-4 border-l-darkOrangeColor bg-secondaryColor",
                    )}
                  >
                    <motion.div onClick={() => setSelectedList(item.id)} variants={touchVariants} initial="initial" whileTap="tap">
                      <motion.div
                        className="flex gap-x-2 items-center"
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={listItemVariants}
                        transition={{
                          duration: 0.3,
                          delay: index * 0.1,
                        }}
                      >
                        <div className="overflow-hidden flex justify-start items-center">
                          {/* <img
                        src={item.icon}
                        width={15}
                        height={15}
                        alt={item.name ? `${item.name} icon` : "Icon"}
                        className={cn("object-fill min-w-10 min-h-10 max-h-10 max-w-10", ICON_ITEM_SHAPE[shape || "rectangle"])}
                      /> */}
                          <ImageWithSkeleton
                            url={{
                              small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                              medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                              large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                              hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                              original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                            }}
                            alt={item.name ?? "Icon"}
                            blur_hash={item.img?.bh || BLUR_HASH}
                            className={cn("object-cover max-w-[90px] max-h-[90px]")}
                            // className={cn("object-fill min-w-10 min-h-10 max-h-10 max-w-10", ICON_ITEM_SHAPE[shape || "rectangle"])}
                            // roundedClass={ICON_ITEM_SHAPE[shape || "rectangle"]}
                            loadImageLazy={false}
                            isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                            useSkeletonLoader={true}
                          />
                        </div>
                        <p className={cn("icon_category_name !text-start capitalize", regular, selectedList === item.id ? "text-jetBlack" : "")}>
                          {item.name}
                        </p>
                      </motion.div>
                    </motion.div>
                  </SheetClose>
                </div>
              )
            );
          })}
        </div>
      </AnimatePresence>
    </div>
  );
};

export default ListView;
